import { useEffect, useState } from "react";
import axios from "axios";

export default function NotionRedirect() {
  const [error, setError] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");

    // if (!code) {
    //   console.error("No authorization code found in URL");
    //   return;
    // }

    const token = localStorage.getItem("accessToken"); 

    const fetchNotionData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/integration/notion/get-url/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log("✅ Notion integration successful:", response.data);
        // window.location.href = "/";
      } catch (error) {
        console.error("❌ Error during Notion integration:", error.response?.data || error.message);
        setError(true);
      }
    };

    fetchNotionData();
  }, []);

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen text-center">
        <h2 className="text-2xl font-semibold text-red-600">Notion Integration Failed</h2>
        <p className="text-gray-600 mt-2">There was an error connecting to Notion. Please try again.</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center">
      <h2 className="text-2xl font-semibold">Connecting to Notion...</h2>
      <p className="text-gray-600 mt-2">Please wait while we complete the integration.</p>
    </div>
  );
}
